export default __webpack_public_path__ + "static/media/myTransactions.de914996.png";